import React from 'react'
import styled from 'styled-components'

import { GenericContainer } from '../shared/DefaultStyledComponents'
import treningBackground from '../../assets/welcomeScreen/trening_background.png'
import arrow from '../../assets/loginScreen/arrow.png'
import button from '../../assets/loginScreen/button.png'
import videoPlaceholder from '../../assets/loginScreen/video_placeholder.jpg'
import { welcomePageVideo } from '../../constants/videoURL'

import { mediaQ, fontSizeResponsive } from '../theme/mixins'

import GenericBackgroundLayer from '../../GenericComponents/GenericBackgroundLayer'
import GenericLogo from '../../GenericComponents/GenericLogo'
import GenericTextSpan from '../../GenericComponents/GenericTextSpan'

const LoginScreenContainer = styled(GenericContainer)`
  background-image: url(${treningBackground}),
    linear-gradient(130deg, #fe0d9f 1%, #faae01 90%);
  background-size: 115% 115%;
  background-position-y: 15%;
  height: 100vh;

  ${mediaQ('mobileAll', 'background-image: unset')}
`
const LeftSideBox = styled.div`
  width: 49.6875000001%;
  height: 100%;
  background-color: white;
  display: flex;
  ${mediaQ('mobileAll', 'height: 15%;')}
`

const LoginScreenTextBox = styled.div`
  position: absolute;
  width: 21.6145833333%;
  height: 15.3703703704%;
  display: flex;
  flex-direction: column;
  font-family: 'Asap';
  ${fontSizeResponsive(44)};
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.23;
  letter-spacing: normal;
  text-align: left;
  color: #212121;
  left: 10.9895833333%;
  align-self: center;

  ${mediaQ('mobileAll', 'width: 100%; left:0;justify-content: center;')}
`
const LoginTextLine = styled.span`
  width: 100%;
  display: block;
  white-space: pre;

  ${mediaQ('mobileAll', 'text-align: center;')};
  ${fontSizeResponsive(33)};
`
const SkipButtonContainer = styled.div`
  display: flex;
  position: absolute;
  align-items: center;
  left: 10.9895833333%;
  top: 22.7777777778%;
  ${mediaQ('mobileAll', 'display:none')}
`
const SkipButton = styled.button`
  background-color: transparent;
  outline: none;
  font-family: 'Open Sans', sans-serif;
  ${fontSizeResponsive(19)};
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.79;
  letter-spacing: 0.95px;
  text-align: left;
  color: #fe0d9f;
  text-transform: uppercase;
  border: none;
`
const ArrowRight = styled.div`
  background-image: url(${arrow});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: calc((1920px / 331.034482759));
  height: calc((1080px / 93.9130434783));
`

const MainButton = styled.button`
  background-image: url(${button});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 14.0104166667%;
  height: 6.20370370369%;
  position: absolute;
  border: none;
  outline: none;
  top: 63.2407407406%;
  left: 10.9895833333%;
  background-color: transparent;
  padding: 0px;

  ${mediaQ('mobileAll', 'top:15%; left:calc(50% - (35% / 2));width: 35%')}
`

export const VideoBox = styled.video`
  background-image: url(${(props) => props.videoPlaceholder});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 50%;
  height: 50%;
  align-self: center;
  position: absolute;
  right: 25%;
  bottom: 30vh;
  cursor: pointer;

  ${mediaQ(
    'mobileAll',
    'height:40%;top:30%;width:100%;right:0;object-fit: cover;background:none;'
  )}
`

const LoginScreen = ({ videoStart, redirectTo, videoWatched }) => {
  const openBlankSite = () => {
    window.open('https://fitmatkawariatka.pl/metamorfoza/', '_blank')
  }

  const noContextMenu = () => {}
  return (
    <GenericBackgroundLayer
      fDir={'column'}
      justify={'flex-start'}
      align={'center'}
      className={'standard'}
    >
      <LeftSideBox>
        <SkipButtonContainer onClick={videoWatched}>
          {/* <SkipButton>Pomiń</SkipButton> */}
          {/* <ArrowRight /> */}
        </SkipButtonContainer>
        {/* <LoginScreenTextBox>
          <LoginTextLine>Przemiany</LoginTextLine>
          <LoginTextLine>innych dziewczyn</LoginTextLine>
          <LoginTextLine>z Miazgi</LoginTextLine>
        </LoginScreenTextBox> */}
        {/* <MainButton onClick={openBlankSite} /> */}
      </LeftSideBox>
      {/* <VideoBox
        onClick={videoStart}
        controlsList="nodownload"
        onContextMenu={noContextMenu}
        autoPlay
        playsinline
        // videoPlaceholder={videoPlaceholder}
        // onEnded={videoWatched}
        playsInline
        controls="false"
        src={welcomePageVideo}
        type="video/mp4"
      >
         */}
      {/* <source
          src={welcomePageVideo}
          type="video/mp4"
          onClick={(e) => videoStart(e)}
        /> */}
      {/* </VideoBox> */}
      <GenericTextSpan top={'16%'} position="absolute" fSize={'1.2rem'}>
        Obejrzyj film do końca
      </GenericTextSpan>
      <video
        className="welcome-video"
        autoPlay
        playsinline={true}
        playsInline
        webkit-playsinline={true}
        webkit-playsInline
        onClick={(e) => videoStart(e)}
        controlsList="nodownload"
        onContextMenu={noContextMenu}
        src={welcomePageVideo}
        type="video/mp4"
        onEnded={videoWatched}
      ></video>
      <GenericLogo position={'absolute'} bottom={'8%'} />
    </GenericBackgroundLayer>
  )
}

export default LoginScreen
